  import DemoUserInfo from '@/components/demoComponents/demoUtils/demoUserInfo';

export default class DemoAnswers {
  player: DemoUserInfo
  remoteUser1: DemoUserInfo
  remoteUser2: DemoUserInfo
  remoteUser3: DemoUserInfo
  didPlayerSubmitResponse: Array<boolean>
  constructor(player: DemoUserInfo, remoteUser1: DemoUserInfo, remoteUser2: DemoUserInfo, remoteUser3: DemoUserInfo) {
    this.player = player;
    this.remoteUser1 = remoteUser1;
    this.remoteUser2 = remoteUser2;
    this.remoteUser3 = remoteUser3;
    // by default, assume that the player did submit a response, and if they didn't submit a response, these flags will be modified
    this.didPlayerSubmitResponse = [true, true]
  }
  // default answers for if the user does not answer
  getEmptyPlayerAnswer1() {
    this.didPlayerSubmitResponse[0] = false;
    return {
      gameRoomcode: "ABCDEFGH",
      replyType: "gif",
      roundIndex: 0,
      turnIndex: 1,
      answerId: 1,
      instantiatedPromptText: "When someone sends you an email and cc's your boss",
      promptType: "static",
      answerHighResGifUrl: "",
      answerHighResMp4Url: "",
      answerLowResGifUrl: "",
      answerText: "",
      username: this.player.name,
      primaryColor: this.player.primary,
      score: 0,
      numVotes: 0,
      wasSubmitted: false
    }
  }

  getEmptyPlayerAnswer2() {
    this.didPlayerSubmitResponse[1] = false;
    return {
      gameRoomcode: "ABCDEFGH",
      replyType: "gif",
      roundIndex: 0,
      turnIndex: 1,
      answerId: 0,
      instantiatedPromptText: "Me clicking 'Leave Meeting' while everyone is saying goodbye",
      promptType: "static",
      answerHighResGifUrl: "",
      answerHighResMp4Url: "",
      answerLowResGifUrl: "",
      answerText: "",
      username: this.player.name,
      primaryColor: this.player.primary,
      score: 0,
      numVotes: 0,
      wasSubmitted: false
    }
  }

  // these 2 responses are for responses that are paired with the player - they have a score of 0 and no votes to simulate
  // noone voting for these responses - the user gets all the votes
  getRemoteUser1Answer1() {
    return {
      gameRoomcode: "ABCDEFGH",
      replyType: "gif",
      roundIndex: 0,
      turnIndex: 1,
      answerId: 0,
      instantiatedPromptText: "When someone sends you an email and cc's your boss",
      promptType: "static",
      answerHighResGifUrl: "https://media.tenor.com/images/4bd02aaca30ff95f0a0acf09bb2f9b9a/tenor.gif",
      answerHighResMp4Url: "https://media.tenor.com/videos/84c65561f8398086d91d0a1a32e844e4/mp4",
      answerLowResGifUrl: "https://media.tenor.com/images/fcfae7440e38dfd46cad4be357bd298a/tenor.gif",
      answerText: "",
      username: this.remoteUser1.name,
      primaryColor: this.remoteUser1.primary,
      score: this.didPlayerSubmitResponse[0]? 0 : 40,
      numVotes: this.didPlayerSubmitResponse[0]? 0 : 2,
      wasSubmitted: true
    }
  }
  getRemoteUser2Answer1() {
    return {
      gameRoomcode: "ABCDEFGH",
      replyType: "gif",
      roundIndex: 0,
      turnIndex: 1,
      answerId: 1,
      instantiatedPromptText: "Me clicking 'Leave Meeting' while everyone is saying goodbye",
      promptType: "static",
      answerHighResGifUrl: "https://media.tenor.com/images/b0bcc913d622ca040628c14d04dc6cad/tenor.gif",
      answerHighResMp4Url: "https://media.tenor.com/videos/f1673c12d52e7d29f4185890df3f0346/mp4",
      answerLowResGifUrl: "https://media.tenor.com/images/0c635ad15db3d1e1c6d1c883dd8c9c80/tenor.gif",
      answerText: "",
      username: this.remoteUser2.name,
      primaryColor: this.remoteUser2.primary,
      score: this.didPlayerSubmitResponse[1]? 0 : 40,
      numVotes: this.didPlayerSubmitResponse[1]? 0 : 2,
      wasSubmitted: true
    }
  }
  // next 4 responses are for when the user votes on an option - here the ai will always vote for the other option so that 
  // the user can win (this way the score is split). Since we have 4 users in total (1 player and 3 ai), 2 users will vote
  // every turn, so we must make it a split vote to guarantee the user will win (otherwise the points will be doubled if)
  // both the ai and the player vote for the same thing multiple times. the 'didPlayerVote' is used in case the player did 
  // not vote, in which case we need to change the scoring a bit
  getRemoteUser3Answer1(didPlayerVote : boolean) {
    return {
      gameRoomcode: "ABCDEFGH",
      replyType: "gif",
      roundIndex: 0,
      turnIndex: 1,
      answerId: 0,
      instantiatedPromptText: `What ${this.player.name} looks like when they're in 'WORK MODE'`,
      promptType: "dynamic",
      answerHighResGifUrl: "https://media.tenor.com/images/9f722203b3a72c96e42bc1ce3e6f01a4/tenor.gif",
      answerHighResMp4Url: "https://media.tenor.com/videos/0d08c9099cc0f4fcf2e493e52fbcfb88/mp4",
      answerLowResGifUrl: "https://media.tenor.com/images/93c45097d4566c79e1b58fa154e5c99f/tenor.gif",
      answerText: "",
      username: this.remoteUser3.name,
      primaryColor: this.remoteUser3.primary,
      score: didPlayerVote? 5 : 0,
      numVotes: didPlayerVote? 1: 0,
      wasSubmitted: true
    }
  }
  getRemoteUser1Answer2(didPlayerVote : boolean) {
    return {
      gameRoomcode: "ABCDEFGH",
      replyType: "gif",
      roundIndex: 0,
      turnIndex: 2,
      answerId: 1,
      instantiatedPromptText: `What ${this.player.name} looks like when they're in 'WORK MODE'`,
      promptType: "dynamic",
      answerHighResGifUrl: "https://media.tenor.com/images/7f86cbee7b3996b6d5f50051d9aefebc/tenor.gif",
      answerHighResMp4Url: "https://media.tenor.com/videos/0ed09054a2d0000d761c53ff4989c84d/mp4",
      answerLowResGifUrl: "https://media.tenor.com/images/850ddd1cad83b0a020283863710d6601/tenor.gif",
      answerText: "",
      username: this.remoteUser1.name,
      primaryColor: this.remoteUser1.primary,
      score: didPlayerVote? 5 : 10,
      numVotes: didPlayerVote? 1 : 1,
      wasSubmitted: true
    }
  }
  getRemoteUser2Answer2(didPlayerVote : boolean) {
    return {
      gameRoomcode: "ABCDEFGH",
      replyType: "text",
      roundIndex: 0,
      turnIndex: 2,
      answerId: 0,
      instantiatedPromptText: `${this.player.name}'s best quality`,
      promptType: "dynamic",
      answerHighResGifUrl: "",
      answerHighResMp4Url: "",
      answerLowResGifUrl: "",
      answerText: "Their ability to see a product demo right through to the end",
      username: this.remoteUser2.name,
      primaryColor: this.remoteUser2.primary,
      score: didPlayerVote? 5 : 0,
      numVotes: didPlayerVote? 1 : 0,
      wasSubmitted: true
    }
  }
  getRemoteUser3Answer2(didPlayerVote: boolean) {
    return {
      gameRoomcode: "ABCDEFGH",
      replyType: "text",
      roundIndex: 0,
      turnIndex: 2,
      answerId: 1,
      instantiatedPromptText: `${this.player.name}'s best quality`,
      promptType: "dynamic",
      answerHighResGifUrl: "",
      answerHighResMp4Url: "",
      answerLowResGifUrl: "",
      answerText: "Their determination to find a great game to play with their team ;)",
      username: this.remoteUser3.name,
      primaryColor: this.remoteUser3.primary,
      score: didPlayerVote? 5 : 10,
      numVotes: didPlayerVote? 1 : 1,
      wasSubmitted: true
    }
  }
}
